import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { ParametersService } from './core/services/parameters.service';
import { Keys, PersistenceService } from './core/services/persistence.service';
import * as fromRoot from './store';
import { I18nService } from './core/services/i18n.service';
import { AuthService } from './login/services/auth.service';
import { TokenService } from './core/services/token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Cadena';

  constructor(
    private persistenseService: PersistenceService,
    private store: Store<fromRoot.AuthState>,
    private parametersService: ParametersService,
    private i18nService: I18nService,
    private tokenService: TokenService,
    private authService: AuthService
  ) {
    this.parametersService.configuration();
    this.i18nService.initLanguage();
    const token = this.persistenseService.getValue(Keys.accessToken);
    if (token && this.tokenService.isExpired()) {
      this.authService.cleanSession();
    } else {
      const role = JSON.parse(persistenseService.getValue(Keys.role));
      if (token) {
        this.store.dispatch(fromRoot.loginSuccess({ access_token: token }));
        this.store.dispatch(fromRoot.setCurrentRole({ role }));
      }
    }
  }
}
